







import { defineComponent, ref } from "@vue/composition-api";
import { WelcomeMessage } from "@scrile/api-provider/dist/api/WelcomeMessagesProvider";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { EVENTS } from "@/const";
import FollowingSettingsView from "./components/FollowingSettingsView.vue";

export default defineComponent({
  name: "PageFollowingSettings",
  components: { FollowingSettingsView },
  setup() {
    const SUBJECT_ID = "0";
    const saveWelcomeMessage = ref<(subjectId: string) => Promise<WelcomeMessage[] | undefined>>();
    const updateWelcomeMessage = async () => {
      if (!saveWelcomeMessage.value) return;
      const response = await saveWelcomeMessage.value(SUBJECT_ID);
      if (!!response) {
        emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: $t("Changes saved"), timeout: 1000 });
      }
    };

    return {
      SUBJECT_ID,
      updateWelcomeMessage,
      saveWelcomeMessage,
    };
  },
});
